module.exports = __webpack_public_path__ + "img/ci-front-chl.29e8db8e.svg";